import React from 'react';
import {Col, Row} from 'react-bootstrap';


import {SurveyNavigation} from './SurveyNavigation';
import {SurveyFormSection} from "./SurveyFormSection";
import {useIsSectionComplete, useSectionsWithCompletion} from "../../../Hooks/SurveyFormNavigationHooks";
import {ProjectContactsProvider} from "./ProjectContactsContext";
import {BOUNDARY_CODE} from "../../../Hooks/SubmissionBoundaryHooks";

export const SurveyForm = (props) => {
    
    const {
        answers,
        friendlyAnswers,
        conservationAction,
        survey = {},
        
        customData = {},
        customSections = {},
        
        isValid,
        validation = {},
        
        OnAnswerChange,
        OnValidation,
        DeleteAnswer,
        OnCustomDataChange,
        OnConservationActionChange,
        OnSave,
        OnFinish,

        editMode,

        // Optional: (section) => boolean. When true, that section renders read-only
        // regardless of editMode. Used to lock sections below customSubmissionBoundary
        // for users without review_survey_submissions.
        isSectionReadOnly = () => false,

        ...remaining

    } = props;
    
    const sections = useSectionsWithCompletion(survey, conservationAction, customSections, customData, answers);
    
    const getQuestionAnswer = (question) => {
        if(answers) {
            // SB-3022: resolve by question `code`. Every answer carries its question's code, so an
            // answer carried over from another subprogram's survey (stale surveyQuestionId, same code)
            // still resolves here.
            let answer = answers.find((x) => (x.code != null && x.code !== '') && String(x.code) === String(question.code));

            if(answer) {
                return answer;
            }
        }

        return null;
    }
    
    const { } = props;

    if(conservationAction) {
        // "Save and Finish" should appear both on the very last editable section
        // and on the last editable section *before* the customSubmissionBoundary
        // (the boundary is rendered by a custom component without a footer, and
        // for non-reviewers it's where the supplier-editable portion ends).
        const lastEditableSectionIndex = sections.reduce(
            (lastIdx, section, idx) => !isSectionReadOnly(section) ? idx : lastIdx,
            -1
        );
        const boundaryIdx = sections.findIndex(s => s.code === BOUNDARY_CODE);
        const lastBeforeBoundaryIdx = boundaryIdx > 0 ? boundaryIdx - 1 : -1;
        const isLastSection = (idx) =>
            idx === lastEditableSectionIndex || idx === lastBeforeBoundaryIdx;

        return <ProjectContactsProvider projectId={conservationAction.projectId} editMode={editMode}>
            <Row className={"sb-survey-form " + (editMode ? "editing " : "")} >
                <Col xs={9}>
                    {
                        sections.map((section, sectionIndex) =>
                            <SurveyFormSection
                                conservationAction={conservationAction}
                                survey={survey}
                                section={section}
                                answers={answers}
                                friendlyAnswers={friendlyAnswers}
                                key={section.surveySectionId}

                                customData={customData}
                                customSections={customSections}

                                validation={validation}
                                editMode={editMode && !isSectionReadOnly(section)}
                                isValid={isValid}
                                isLastSection={isLastSection(sectionIndex)}

                                getQuestionAnswer={getQuestionAnswer}

                                OnAnswerChange={OnAnswerChange}
                                OnValidation={OnValidation}
                                DeleteAnswer={DeleteAnswer}
                                OnCustomDataChange={OnCustomDataChange}
                                OnConservationActionChange={OnConservationActionChange}
                                OnSave={OnSave}
                                OnFinish={OnFinish}
                            />)
                    }
                </Col>
                <Col xs={3} className="sb-section-navigator">
                    <SurveyNavigation
                        Sections={sections}
                        GetQuestionAnswer={getQuestionAnswer}
                        Survey={survey}
                        ConservationAction={conservationAction}
                        CustomSections={customSections}
                        CustomData={customData}
                    />
                </Col>
            </Row>
        </ProjectContactsProvider>;
    }

    return null;
}


